import * as pathUtil from 'path'
import InfraUtil from './InfraUtil'

class Resource {
  static arrayFrom(paths, root) {
    const resourcesByPath = {}
    paths.forEach(path => {
      if (path === '') {
        return
      }

      const existing = resourcesByPath[path]
      if (existing) {
        return
      }

      const dirname = pathUtil.dirname(path)
      if (dirname === '') {
        return
      }

      var dir = resourcesByPath[dirname]
      if (dir === undefined) {
        dir = new this(dirname)
        resourcesByPath[dirname] = dir
      }

      const resource = new this(pathUtil.join(root, path))
      dir.children.push(resource)
      resourcesByPath[path] = resource
    })

    return resourcesByPath['.'].children
  }

  constructor(path) {
    this.path = path
    this.ext = pathUtil.extname(this.path)
    this.children = []

    this.absoluteUrl =  new URL(this.path, InfraUtil.rootURL())
  }

  loadText(handler) {
    fetch(this.absoluteUrl)
    .then(response => response.text())
    .then(text => handler(text))
  }
}

export default Resource


// WEBPACK FOOTER //
// ./src/Infra/Resource.js